import { TrendingUp } from "lucide-react";
import PropertyManagementContactForm from "./PropertyManagementContactForm";
const PropertyManagementHeader = () => <section className="relative bg-gradient-to-br from-brand-primary to-brand-primary-hover py-20 md:py-28">
    <div className="absolute inset-0 bg-black/20"></div>

    <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-2 gap-8 items-start">
        <div className="text-center md:text-left">
          <h1 className="text-4xl md:text-6xl md:leading-tight font-bold text-white mb-6">
            Gestionamos tu propiedad, maximizamos tus ingresos <br />
            
          </h1>

          <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto md:mx-0 leading-relaxed">
            Nos encargamos de todo para que tú solo te preocupes por tus ingresos
          </p>

          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 text-white border border-white/20">
            <TrendingUp className="w-5 h-5 mr-2 text-green-300" />
            <span className="font-semibold">Comisión: 15% sobre ingresos + $1,500 MXN/mes</span>
          </div>
        </div>

        <aside className="hidden md:block">
          <PropertyManagementContactForm embedded />
        </aside>
      </div>
    </div>
  </section>;
export default PropertyManagementHeader;